import { Button } from "reactstrap";
import AppSpinner from "../../elements/AppSpinner";
import classNames from "classnames";
import { methods } from "./Login";

type OAuths = "google" | "amazon" | "office365" | "linkedin";
type Redirecting = OAuths | false;

interface OAuthButtonProps {
  onClick: () => void;
  logo: any;
  redirecting: Redirecting;
  method: OAuths;
  continueWith?: boolean;
}

const OAuthButton = ({
  onClick,
  logo,
  redirecting,
  method,
  continueWith = false,
}: OAuthButtonProps) => {
  const isRedirecting = redirecting === method;

  if (continueWith) {
    return (
      <Button
        className="btn-icon tw:border tw:border-superlight btn-oauth tw:mb-3 mx-0 "
        color="white"
        block={true}
        onClick={onClick}
        disabled={!!redirecting}
      >
        <span
          className="btn-inner--icon mr-1"
          style={{ position: "absolute", left: "0.75rem" }}
        >
          <img alt="..." src={logo} style={{ color: "black" }} />
        </span>
        <span
          className={classNames("btn-inner--text", {
            "text-primary": isRedirecting,
          })}
        >
          {isRedirecting ? (
            <>
              Continuing with {methods[method]}
              <AppSpinner
                color="primary"
                style={{ position: "relative", right: -10, top: -2 }}
              />
            </>
          ) : (
            <>Continue with {methods[method]}</>
          )}
        </span>
      </Button>
    );
  }

  return (
    <Button
      className="tw:shadow-[1px_2px_3px_1px_rgba(0,0,0,0.25)] tw:width-[48px] tw:height-[48px] tw:rounded-full tw:p-4"
      color="white"
      onClick={onClick}
      disabled={!!redirecting}
    >
      <img alt="..." src={logo} style={{ color: "black", width: "20px" }} />

      <span>
        {isRedirecting && (
          <AppSpinner
            style={{ position: "absolute", top: "18px", left: "18px" }}
          />
        )}
      </span>
    </Button>
  );
};

export default OAuthButton;
